// Import the functions you need from the SDKs you need
import config from "@app/config/getConfig";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import {
  connectFirestoreEmulator,
  initializeFirestore,
} from "firebase/firestore";

declare global {
  var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string | undefined;
}

// Initialize Firebase
const app = initializeApp(config.firebase);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
});

if (config.useEmulators === true) {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.VITE_CHECK_TOKEN;
}

if (process.env.JEST_WORKER_ID === undefined) {
  // Only initialize App Check in non-test environments
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(config.recatchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

if (config.useEmulators === true) {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
}

export default db;
